import { esgDashboardStore } from "../stores";

export const useEsgDashboardStore = () => esgDashboardStore;
